import type { SupportedLanguage } from './index';

export interface LanguageMeta {
  code: SupportedLanguage;
  englishName: string;
  nativeName: string;
  flag: string;
  rtl?: boolean;
}

export const LANGUAGES: readonly LanguageMeta[] = [
  { code: 'en', englishName: 'English',    nativeName: 'English',          flag: '🇺🇸' },
  { code: 'ja', englishName: 'Japanese',   nativeName: '日本語',            flag: '🇯🇵' },
  { code: 'ko', englishName: 'Korean',     nativeName: '한국어',            flag: '🇰🇷' },
  { code: 'zh', englishName: 'Chinese',    nativeName: '中文',              flag: '🇨🇳' },
  { code: 'de', englishName: 'German',     nativeName: 'Deutsch',          flag: '🇩🇪' },
  { code: 'fr', englishName: 'French',     nativeName: 'Français',         flag: '🇫🇷' },
  { code: 'es', englishName: 'Spanish',    nativeName: 'Español',          flag: '🇪🇸' },
  { code: 'pt', englishName: 'Portuguese', nativeName: 'Português',        flag: '🇧🇷' },
  { code: 'hi', englishName: 'Hindi',      nativeName: 'हिन्दी',              flag: '🇮🇳' },
  { code: 'id', englishName: 'Indonesian', nativeName: 'Bahasa Indonesia', flag: '🇮🇩' },
  { code: 'ar', englishName: 'Arabic',     nativeName: 'العربية',            flag: '🇸🇦', rtl: true },
  { code: 'bn', englishName: 'Bengali',    nativeName: 'বাংলা',              flag: '🇧🇩' },
  { code: 'ru', englishName: 'Russian',    nativeName: 'Русский',          flag: '🇷🇺' },
  { code: 'ur', englishName: 'Urdu',       nativeName: 'اردو',               flag: '🇵🇰', rtl: true },
];
